import {Pipe, PipeTransform} from '@angular/core';
import {CashClosingDto} from '../../../Models/Finances/Cash-closing/cash-closing.interface';

@Pipe({
  name: 'cashClosing',
  standalone: false
})
export class CashClosingPipe implements PipeTransform {

  transform(items: CashClosingDto[], filter: { local?: number; shift?: number }): CashClosingDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.local) {
      items = items.filter((item) => item['id_local'] === filter.local);
    }

    if (filter.shift) {
      items = items.filter((item) => item['id_turno'] === filter.shift);
    }

    return items;

  }

}
